
const UnAuthorized = () => {
  return (
    <div>403 - Unauthorized</div>
  )
}

export default UnAuthorized;